"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabTypeEnum = void 0;
var TabTypeEnum;
(function (TabTypeEnum) {
    TabTypeEnum["INBOX_INVOICES"] = "INBOX_INVOICES";
    TabTypeEnum["PROCUREMENT"] = "PROCUREMENT";
    TabTypeEnum["TO_DOS"] = "TO_DOS";
    TabTypeEnum["MY_TO_DOS"] = "MY_TO_DOS";
    TabTypeEnum["REVIEW"] = "REVIEW";
    TabTypeEnum["PAY_EXPORT"] = "PAY_EXPORT";
    TabTypeEnum["DONE"] = "DONE";
    TabTypeEnum["ARCHIVE"] = "ARCHIVE";
    TabTypeEnum["IN_PROGRESS"] = "IN_PROGRESS";
    TabTypeEnum["ALL"] = "ALL";
})(TabTypeEnum || (exports.TabTypeEnum = TabTypeEnum = {}));
